(() => {
  const header = document.querySelector("[data-dg-header]");
  const toggle = document.querySelector("[data-dg-menu-toggle]");

  if (!header || !toggle) return;

  toggle.addEventListener("click", () => {
    const isOpen = header.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });
})();

(() => {
  const triggers = document.querySelectorAll("[data-dg-variant-trigger]");
  const directForms = document.querySelectorAll(".dg-card-hover__form");
  const modals = document.querySelectorAll("[data-dg-variant-modal]");
  const productForms = document.querySelectorAll("product-form form");
  const buyNowButtons = document.querySelectorAll("[data-dg-buy-now]");
  const cartRailElement = document.querySelector("[data-dg-cart-rail]");
  if (!cartRailElement && !triggers.length && !directForms.length && !modals.length && !productForms.length && !buyNowButtons.length) return;

  modals.forEach((modal) => {
    document.body.appendChild(modal);
  });

  let activeModal = null;
  let activeTrigger = null;

  const openModal = (modal, trigger) => {
    activeModal = modal;
    activeTrigger = trigger;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("dg-variant-modal-open");
    const checkedInput = modal.querySelector("input[name='id']:checked:not(:disabled)");
    const firstInput = modal.querySelector("input[name='id']:not(:disabled)");
    const closeButton = modal.querySelector("[data-dg-variant-close]");
    (checkedInput || firstInput || closeButton)?.focus();
  };

  const closeModal = () => {
    if (!activeModal) return;
    activeModal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("dg-variant-modal-open");
    activeTrigger?.focus();
    activeModal = null;
    activeTrigger = null;
  };

  const cartCountElements = () => document.querySelectorAll("[data-dg-cart-count]");
  const simpleCardControls = () => document.querySelectorAll("[data-dg-card-control]");
  const productCartControls = () => document.querySelectorAll("[data-dg-product-cart-control]");
  const cartRail = () => document.querySelector("[data-dg-cart-rail]");
  const cartRailSubtotal = () => document.querySelector("[data-dg-cart-rail-subtotal]");
  const cartRailItems = () => document.querySelector("[data-dg-cart-rail-items]");
  const syncCartRailPosition = () => {
    const rail = cartRail();
    const headerBar = document.querySelector(".dg-header__bar");
    if (!rail || !headerBar) return;

    const headerBottom = Math.max(0, Math.round(headerBar.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty("--dg-cart-rail-top", `${headerBottom}px`);
  };
  const trashIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 4h8l1 2h4v2H3V6h4l1-2Zm-2 6h12l-1 11H7L6 10Zm3 2 .5 7h1.7l-.3-7H9Zm4 0-.3 7h1.8l.5-7h-2Z" fill="currentColor"/></svg>';
  const minusIcon = '<span class="dg-card-cart-control__minus" aria-hidden="true">-</span>';

  const ajaxRoute = (route, fallback) => {
    const endpoint = route || fallback;
    return endpoint.endsWith(".js") ? endpoint : `${endpoint.replace(/\/$/, "")}.js`;
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || "EUR";
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency,
    }).format((Number(cents) || 0) / 100);
  };

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;",
  }[character]));

  const setButtonFeedback = (button) => {
    if (!button) return;
    button.classList.add("is-added-feedback");
    window.setTimeout(() => {
      button.classList.remove("is-added-feedback");
    }, 2000);
  };

  const updateSimpleCardControls = (cart) => {
    if (!cart || !simpleCardControls().length) return;

    const cartItemsByVariant = cart.items.reduce((totals, item) => {
      const variantId = String(item.variant_id);
      if (!totals[variantId]) {
        totals[variantId] = {
          key: item.key,
          quantity: 0,
        };
      }
      totals[variantId].quantity += item.quantity;
      return totals;
    }, {});

    simpleCardControls().forEach((control) => {
      const variantId = String(control.dataset.dgVariantId || "");
      const cartItem = cartItemsByVariant[variantId];
      const quantity = cartItem?.quantity || 0;
      const card = control.closest(".card");
      const form = card?.querySelector(".dg-card-action__form");
      const qty = control.querySelector("[data-dg-card-qty]");
      const adjustButton = control.querySelector("[data-dg-card-remove]");

      if (cartItem?.key) {
        control.dataset.dgLineKey = cartItem.key;
      } else {
        delete control.dataset.dgLineKey;
      }

      if (qty) qty.textContent = quantity;
      if (adjustButton) {
        const isDecrease = quantity > 1;
        adjustButton.dataset.dgCardMode = isDecrease ? "decrease" : "remove";
        adjustButton.classList.toggle("is-decrease", isDecrease);
        control.classList.toggle("is-multiple", isDecrease);
        adjustButton.setAttribute("aria-label", isDecrease ? "Aantal met 1 verlagen" : "Product verwijderen uit winkelwagen");
        const nextIcon = isDecrease ? "minus" : "trash";
        if (adjustButton.dataset.dgCardIcon !== nextIcon) {
          adjustButton.innerHTML = isDecrease ? minusIcon : trashIcon;
          adjustButton.dataset.dgCardIcon = nextIcon;
        }
      }
      control.classList.toggle("is-visible", quantity > 0);
      form?.classList.toggle("is-hidden", quantity > 0);
    });
  };

  const getProductVariantId = (control) => {
    const productScope = control.closest("product-info") || control.closest(".product") || document;
    const variantInput = productScope.querySelector("product-form form input[name='id'], .product-variant-id");
    return String(variantInput?.value || control.dataset.dgVariantId || "");
  };

  const updateProductCartControls = (cart) => {
    if (!cart || !productCartControls().length) return;

    const cartItemsByVariant = cart.items.reduce((totals, item) => {
      const variantId = String(item.variant_id);
      if (!totals[variantId]) {
        totals[variantId] = {
          key: item.key,
          quantity: 0,
        };
      }
      totals[variantId].quantity += item.quantity;
      return totals;
    }, {});

    productCartControls().forEach((control) => {
      const variantId = getProductVariantId(control);
      const cartItem = cartItemsByVariant[variantId];
      const quantity = cartItem?.quantity || 0;
      const qty = control.querySelector("[data-dg-product-qty]");
      const adjustButton = control.querySelector("[data-dg-product-remove]");

      if (variantId) control.dataset.dgVariantId = variantId;
      if (cartItem?.key) {
        control.dataset.dgLineKey = cartItem.key;
      } else {
        delete control.dataset.dgLineKey;
      }

      control.dataset.dgCurrentQuantity = String(quantity);
      if (qty) qty.textContent = quantity;
      if (adjustButton) {
        const isDecrease = quantity > 1;
        adjustButton.dataset.dgProductMode = isDecrease ? "decrease" : "remove";
        adjustButton.classList.toggle("is-decrease", isDecrease);
        control.classList.toggle("is-multiple", isDecrease);
        adjustButton.setAttribute("aria-label", isDecrease ? "Aantal met 1 verlagen" : "Product verwijderen uit winkelwagen");
        const nextIcon = isDecrease ? "minus" : "trash";
        if (adjustButton.dataset.dgProductIcon !== nextIcon) {
          adjustButton.innerHTML = isDecrease ? minusIcon : trashIcon;
          adjustButton.dataset.dgProductIcon = nextIcon;
        }
      }
      control.classList.toggle("is-visible", quantity > 0);
    });
  };

  const renderCartRail = (cart) => {
    const rail = cartRail();
    if (!rail || !cart) return;

    syncCartRailPosition();

    const isCartPage = window.location.pathname.replace(/\/$/, "") === "/cart";
    const isVisible = cart.item_count > 0 && !isCartPage;
    rail.classList.toggle("is-visible", isVisible);
    rail.setAttribute("aria-hidden", isVisible ? "false" : "true");
    document.documentElement.classList.toggle("dg-cart-rail-active", isVisible);

    const subtotal = cartRailSubtotal();
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    const itemsContainer = cartRailItems();
    if (!itemsContainer) return;

    itemsContainer.innerHTML = cart.items.map((item) => {
      const title = escapeHtml(item.product_title || item.title);
      const itemUrl = escapeHtml(item.url || "#");
      const image = escapeHtml(item.image || item.featured_image?.url || "");
      const variantTitle = item.variant_title && item.variant_title !== "Default Title"
        ? `<span class="dg-cart-rail__variant">${escapeHtml(item.variant_title)}</span>`
        : "";
      const quantity = Number(item.quantity) || 0;
      const isDecrease = quantity > 1;
      const actionIcon = isDecrease ? minusIcon : trashIcon;
      const actionLabel = isDecrease ? "Aantal met 1 verlagen" : "Product verwijderen uit winkelwagen";

      return `
        <article class="dg-cart-rail__item" data-dg-rail-item data-dg-line-key="${escapeHtml(item.key)}" data-dg-variant-id="${escapeHtml(item.variant_id)}" data-dg-current-quantity="${quantity}">
          <a class="dg-cart-rail__image-link" href="${itemUrl}" aria-label="${title}">
            ${image ? `<img class="dg-cart-rail__image" src="${image}" alt="${title}" loading="lazy">` : ""}
          </a>
          <div class="dg-cart-rail__details">
            <a class="dg-cart-rail__title" href="${itemUrl}">${title}</a>
            <span class="dg-cart-rail__price">${formatMoney(item.final_price)}</span>
            ${variantTitle}
            <div class="dg-cart-rail__control" aria-label="Aantal aanpassen">
              <button class="dg-cart-rail__control-button" type="button" data-dg-rail-remove aria-label="${actionLabel}">
                ${actionIcon}
              </button>
              <span class="dg-cart-rail__quantity" data-dg-rail-qty>${quantity}</span>
              <button class="dg-cart-rail__control-button" type="button" data-dg-rail-plus aria-label="${title} toevoegen">
                <span aria-hidden="true">+</span>
              </button>
            </div>
          </div>
        </article>
      `;
    }).join("");
  };

  const updateCartCount = async () => {
    const response = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    const cart = await response.json();

    cartCountElements().forEach((count) => {
      count.textContent = cart.item_count;
      count.setAttribute("aria-label", `${cart.item_count} artikelen in winkelwagen`);
      count.classList.toggle("is-empty", cart.item_count === 0);
    });

    updateSimpleCardControls(cart);
    updateProductCartControls(cart);
    renderCartRail(cart);

    return cart;
  };

  const flyToCart = (sourceElement) => {
    const cartLink = document.querySelector("[data-dg-cart-link]");
    if (!sourceElement || !cartLink) return;

    const sourceRect = sourceElement.getBoundingClientRect();
    const targetRect = cartLink.getBoundingClientRect();
    const flyer = document.createElement("span");

    flyer.className = "dg-cart-flyer";
    flyer.setAttribute("aria-hidden", "true");
    flyer.textContent = "+1";
    flyer.style.left = `${sourceRect.left + sourceRect.width / 2}px`;
    flyer.style.top = `${sourceRect.top + sourceRect.height / 2}px`;
    flyer.style.setProperty("--dg-fly-x", `${targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2)}px`);
    flyer.style.setProperty("--dg-fly-y", `${targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2)}px`);

    document.body.appendChild(flyer);
    flyer.addEventListener("animationend", () => flyer.remove(), { once: true });
    cartLink.classList.remove("is-bumping");
    window.requestAnimationFrame(() => cartLink.classList.add("is-bumping"));
    window.setTimeout(() => cartLink.classList.remove("is-bumping"), 620);
  };

  const addToCart = async (form, triggerButton, status) => {
    const formData = new FormData(form);
    const selectedVariant = formData.get("id");

    if (!selectedVariant) {
      if (status) status.textContent = "Kies eerst een maat.";
      return false;
    }

    triggerButton?.setAttribute("disabled", "disabled");
    if (status) status.textContent = "Wordt toegevoegd...";

    try {
      const response = await fetch(window.routes?.cart_add_url || form.action || "/cart/add", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      });

      const parsedState = await response.json();
      if (!response.ok) throw new Error(parsedState.description || "Toevoegen is niet gelukt.");

      await updateCartCount();
      flyToCart(triggerButton || form);
      if (status) status.textContent = "Toegevoegd aan je winkelwagen.";
      return true;
    } catch (error) {
      if (status) status.textContent = error.message || "Toevoegen is niet gelukt.";
      return false;
    } finally {
      triggerButton?.removeAttribute("disabled");
    }
  };

  const handleVariantSubmit = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    const submitButton = form.querySelector("button[type='submit']");
    const status = form.querySelector("[data-dg-variant-status]");
    const selectedVariant = form.querySelector("input[name='id']:checked:not(:disabled)");

    if (!selectedVariant) {
      if (status) status.textContent = "Kies eerst een maat.";
      return;
    }

    const added = await addToCart(form, submitButton, status);
    if (added) {
      setButtonFeedback(activeTrigger);
      window.setTimeout(() => {
        closeModal();
      }, 520);
    }
  };

  const handleDirectSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const button = form.querySelector(".dg-card-hover__buy");
    const label = button?.querySelector("span:first-child");
    const originalLabel = label?.textContent;
    const added = await addToCart(form, button);

    if (added && button?.dataset.dgCardSimple === "true") return;

    if (added && label) {
      label.textContent = "Toegevoegd";
      setButtonFeedback(button);
      window.setTimeout(() => {
        label.textContent = originalLabel || "In winkelwagen";
      }, 1150);
    }
  };

  const updateCardQuantity = async (button, mode) => {
    const control = button.closest("[data-dg-card-control]");
    const variantId = String(control?.dataset.dgVariantId || "");
    if (!variantId) return;

    button.setAttribute("disabled", "disabled");

    try {
      const currentQuantity = Number(control.querySelector("[data-dg-card-qty]")?.textContent) || 0;
      const nextQuantity = currentQuantity > 1 ? currentQuantity - 1 : 0;
      let changeId = control.dataset.dgLineKey || "";

      if (mode === "remove" && !changeId) {
        const cart = await updateCartCount();
        const cartItem = cart.items.find((item) => String(item.variant_id) === variantId);
        changeId = cartItem?.key || variantId;
        if (cartItem?.key) control.dataset.dgLineKey = cartItem.key;
      }

      const payload = mode === "remove"
        ? { id: changeId || variantId, quantity: nextQuantity }
        : { id: variantId, quantity: 1 };
      const url = mode === "remove"
        ? ajaxRoute(window.routes?.cart_change_url, "/cart/change.js")
        : ajaxRoute(window.routes?.cart_add_url, "/cart/add.js");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const parsedState = await response.json();
      if (!response.ok) throw new Error(parsedState.description || "Winkelwagen bijwerken is niet gelukt.");

      await updateCartCount();
      if (mode === "add") flyToCart(button);
    } catch (error) {
      // Keep the existing visual state if Shopify rejects the cart update.
    } finally {
      button.removeAttribute("disabled");
    }
  };

  const updateProductQuantity = async (button, mode) => {
    const control = button.closest("[data-dg-product-cart-control]");
    const variantId = getProductVariantId(control || button);
    if (!control || !variantId) return;

    button.setAttribute("disabled", "disabled");
    control.classList.add("is-updating");

    try {
      const currentQuantity = Number(control.dataset.dgCurrentQuantity || control.querySelector("[data-dg-product-qty]")?.textContent) || 0;
      const nextQuantity = currentQuantity > 1 ? currentQuantity - 1 : 0;
      let changeId = control.dataset.dgLineKey || "";

      if (mode === "remove" && !changeId) {
        const cart = await updateCartCount();
        const cartItem = cart.items.find((item) => String(item.variant_id) === variantId);
        changeId = cartItem?.key || variantId;
        if (cartItem?.key) control.dataset.dgLineKey = cartItem.key;
      }

      const payload = mode === "remove"
        ? { id: changeId || variantId, quantity: nextQuantity }
        : { id: variantId, quantity: 1 };
      const url = mode === "remove"
        ? ajaxRoute(window.routes?.cart_change_url, "/cart/change.js")
        : ajaxRoute(window.routes?.cart_add_url, "/cart/add.js");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const parsedState = await response.json();
      if (!response.ok) throw new Error(parsedState.description || "Winkelwagen bijwerken is niet gelukt.");

      await updateCartCount();
      if (mode === "add") flyToCart(button);
    } catch (error) {
      // Keep the current product-page counter untouched when Shopify rejects an update.
    } finally {
      control.classList.remove("is-updating");
      button.removeAttribute("disabled");
    }
  };

  const updateRailQuantity = async (button, mode) => {
    const item = button.closest("[data-dg-rail-item]");
    const lineKey = item?.dataset.dgLineKey || "";
    const variantId = String(item?.dataset.dgVariantId || "");
    const currentQuantity = Number(item?.dataset.dgCurrentQuantity) || 0;
    if (!item || (!lineKey && !variantId)) return;

    button.setAttribute("disabled", "disabled");
    item.classList.add("is-updating");

    try {
      const payload = mode === "remove"
        ? { id: lineKey || variantId, quantity: currentQuantity > 1 ? currentQuantity - 1 : 0 }
        : { id: variantId, quantity: 1 };
      const url = mode === "remove"
        ? ajaxRoute(window.routes?.cart_change_url, "/cart/change.js")
        : ajaxRoute(window.routes?.cart_add_url, "/cart/add.js");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const parsedState = await response.json();
      if (!response.ok) throw new Error(parsedState.description || "Winkelwagen bijwerken is niet gelukt.");

      await updateCartCount();
      if (mode === "add") flyToCart(button);
    } catch (error) {
      item.classList.remove("is-updating");
    } finally {
      button.removeAttribute("disabled");
    }
  };

  const handleProductSubmit = async (event) => {
    const form = event.currentTarget;
    const button = event.submitter || form.querySelector(".product-form__submit");

    if (!button || !button.classList.contains("product-form__submit")) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const label = button.querySelector("span:not(.sold-out-message)");
    const originalLabel = label?.textContent;
    const added = await addToCart(form, button);

    if (added && label) {
      label.textContent = "Toegevoegd";
      window.setTimeout(() => {
        label.textContent = originalLabel || "Aan winkelwagen toevoegen";
      }, 1150);
    }
  };

  const handleBuyNowClick = async (event) => {
    const button = event.currentTarget;
    const form = button.closest("form");
    if (!form) return;

    button.setAttribute("disabled", "disabled");
    button.textContent = "Laden...";

    const added = await addToCart(form, button);
    if (added) {
      window.location.href = "/checkout";
      return;
    }

    button.removeAttribute("disabled");
    button.textContent = "Nu kopen";
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const modal = document.getElementById(trigger.dataset.dgVariantTrigger);
      if (modal) openModal(modal, trigger);
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-dg-variant-close]")) closeModal();
  });

  document.querySelectorAll("[data-dg-variant-form]").forEach((form) => {
    form.addEventListener("submit", handleVariantSubmit);
  });

  directForms.forEach((form) => {
    if (!form.querySelector("[data-dg-variant-trigger]")) {
      form.addEventListener("submit", handleDirectSubmit);
    }
  });

  productForms.forEach((form) => {
    form.addEventListener("submit", handleProductSubmit, true);
  });

  buyNowButtons.forEach((button) => {
    button.addEventListener("click", handleBuyNowClick);
  });

  document.addEventListener("click", (event) => {
    const railRemoveButton = event.target.closest("[data-dg-rail-remove]");
    if (railRemoveButton) {
      updateRailQuantity(railRemoveButton, "remove");
      return;
    }

    const railPlusButton = event.target.closest("[data-dg-rail-plus]");
    if (railPlusButton) {
      updateRailQuantity(railPlusButton, "add");
      return;
    }

    const productRemoveButton = event.target.closest("[data-dg-product-remove]");
    if (productRemoveButton) {
      updateProductQuantity(productRemoveButton, "remove");
      return;
    }

    const productPlusButton = event.target.closest("[data-dg-product-plus]");
    if (productPlusButton) {
      updateProductQuantity(productPlusButton, "add");
      return;
    }

    const removeButton = event.target.closest("[data-dg-card-remove]");
    if (removeButton) {
      updateCardQuantity(removeButton, "remove");
      return;
    }

    const plusButton = event.target.closest("[data-dg-card-plus]");
    if (plusButton) {
      updateCardQuantity(plusButton, "add");
    }
  });

  document.addEventListener("change", (event) => {
    if (!event.target.matches(".product-variant-id, product-form form input[name='id']")) return;
    window.setTimeout(() => {
      updateCartCount().catch(() => {});
    }, 80);
  });

  updateCartCount();
  window.addEventListener("resize", () => window.requestAnimationFrame(syncCartRailPosition));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeModal();
  });
})();

(() => {
  const galleries = document.querySelectorAll("media-gallery");
  if (!galleries.length) return;

  const getThumbnails = (gallery) => Array.from(gallery.querySelectorAll(".thumbnail-list .thumbnail"));

  const goToImage = (gallery, direction) => {
    const thumbnails = getThumbnails(gallery);
    if (thumbnails.length < 2) return;

    const currentIndex = Math.max(
      thumbnails.findIndex((thumbnail) => thumbnail.getAttribute("aria-current") === "true"),
      0
    );
    const nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
    thumbnails[nextIndex]?.click();
  };

  galleries.forEach((gallery) => {
    gallery.querySelectorAll("slider-component[id^='GalleryViewer'] .slider-button").forEach((button) => {
      button.removeAttribute("disabled");
      button.setAttribute("aria-disabled", "false");
    });
  });

  document.addEventListener("click", (event) => {
    const button = event.target.closest("slider-component[id^='GalleryViewer'] .slider-button");
    if (!button) return;

    const gallery = button.closest("media-gallery");
    if (!gallery) return;

    event.preventDefault();
    event.stopPropagation();
    goToImage(gallery, button.classList.contains("slider-button--next") ? 1 : -1);
  }, true);
})();
